<div class="credits-meter" [class]="size()">
  @if (isLoading()) {
    <div class="credits-meter-skeleton" aria-hidden="true">
      @if (showLabel()) {
        <ngx-skeleton-loader
          appearance="line"
          [animation]="skeletonAnimation()"
          [theme]="{
            height: '14px',
            width: '70%',
            'margin-bottom': '0',
            'border-radius': '4px',
          }"
        ></ngx-skeleton-loader>
      }
      <ngx-skeleton-loader
        appearance="line"
        [animation]="skeletonAnimation()"
        [theme]="{
          height: size() === 'sm' ? '6px' : '8px',
          width: '100%',
          'margin-bottom': '0',
          'border-radius': '999px',
        }"
      ></ngx-skeleton-loader>
    </div>
  } @else {
    @if (showLabel()) {
      <div class="credits-meter-header">
        <p class="credits-meter-label">
          {{
            'company-tool.snippets.credits-counter.available-short'
              | transloco: { count: totalLeftCredits() | number: '1.0-0' }
          }}
        </p>
        @if (showArrow()) {
          <fa-icon
            class="credits-meter-arrow"
            [icon]="fontawesomeService.light.chevronRight"
            aria-hidden="true"
          ></fa-icon>
        }
      </div>
    }

    <p-meterGroup
      [value]="meterValue()"
      [min]="0"
      [max]="meterMax()"
      orientation="horizontal"
      labelPosition="end"
      labelOrientation="horizontal"
    >
      @if (showLegend()) {
        <ng-template #label let-meters>
          <ul class="credits-legend">
            @for (item of meters; track item.label) {
              <li>
                <span
                  class="credits-legend-marker"
                  [style.backgroundColor]="item.color"
                  aria-hidden="true"
                ></span>
                <span class="credits-legend-label">{{ item.label }}</span>
                <b class="credits-legend-value">{{
                  item.value | number: '1.0-0'
                }}</b>
              </li>
            }
          </ul>
        </ng-template>
      }
    </p-meterGroup>
  }
</div>
